import { useState, useEffect } from 'react';
import { getUserPoints } from '../utils/constants';

const useUserPoints = () => {
    const [userPoints, setUserPoints] = useState<number>(getUserPoints());
    useEffect(() => {
        const checkUserPoints = () => {
            const currentLevel = getUserPoints();
            if (currentLevel !== userPoints) {
                setUserPoints(currentLevel);
            }
        };
        const intervalId = setInterval(checkUserPoints, 1000);
        return () => clearInterval(intervalId);
    }, [userPoints]);

    return userPoints;
};

export default useUserPoints;